module.exports = __webpack_public_path__ + "assets/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4taVIGxA-8e70f0.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4taVIGxA.woff2
// module id = 851
// module chunks = 2